import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import { IsValidABNSchema, StringRequiredSchema } from '@/utils';

const BillingDetailsFormSchema = z.object({
  company_name: StringRequiredSchema('Please enter a company name.'),
  company_abn: IsValidABNSchema(),
  first_name: StringRequiredSchema('Please enter a first name.'),
  last_name: StringRequiredSchema('Please enter a last name.'),
  position: StringRequiredSchema('Please enter a position.'),
  email: StringRequiredSchema('Please enter a email.').email(),
});

const BillingAddressFormSchema = z.object({
  address_one: StringRequiredSchema('Please enter a address.'),
  address_two: StringRequiredSchema('Please enter a address.'),
  city: StringRequiredSchema('Please enter a city.'),
  state: StringRequiredSchema('Please enter a state'),
  postal: z.number().nullable(),
  phone: StringRequiredSchema('Please enter a phone'),
});

const SignupFormSchema = z.object({
  billing_details: BillingDetailsFormSchema,
  billing_address: BillingAddressFormSchema,
  offer: z.string(),
  aggrement: z.boolean().refine((value) => value === true, {
    message: 'You must agree to continue.',
  }),
});

export type SignupForm = z.infer<typeof SignupFormSchema>;

export const signupFormDefaultValues: SignupForm = {
  billing_details: {
    company_name: '',
    company_abn: '',
    first_name: '',
    last_name: '',
    position: '',
    email: '',
  },
  billing_address: {
    address_one: '',
    address_two: '',
    city: '',
    state: '',
    postal: null,
    phone: '',
  },
  offer: 'true',
  aggrement: false,
};

export const useSignupForm = () => {
  const form = useForm({
    resolver: zodResolver(SignupFormSchema),
    defaultValues: signupFormDefaultValues,
  });

  return form;
};
